import React from 'react'

const CTA = () => {
  return (
    <div className='cta'>
      <a
        target='_blank'
        href='https://drive.google.com/file/d/1ZYplo_ujHitg2U0k8p09mfHgkwpQL5bB/view?usp=sharing'
        className='btn'
        rel='noreferrer'
      >
        Here's my CV
      </a>
      <a href='#contact' className='btn btn-primary'>
        Contact Me
      </a>
    </div>
  )
}

export default CTA
